export default __webpack_public_path__ + "static/media/shipetiari4.1af5328c.jpg";